/**
 * @docs docs/features/product-domain-listings
 */

import { definePageRoute } from '@common/router/definitions';

import { buildDomainsLandingRouteData, renderDomainsLandingRoute } from './lib/route';

export default definePageRoute({
    path: '/domains/sector/:sector',
    options: { auth: false, layout: false, priority: 20 },
    data: buildDomainsLandingRouteData,
    render: renderDomainsLandingRoute,
});
